import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { cleanUserRoleSelected, startGetRolesByUserIdSelected } from "../../app/actions/userRoleActions";
import { useSortableData } from "../../app/hooks/useSortableData";

import { useTranslation } from "react-i18next";
import { startGetModulesByUserIdSelected } from "../../app/actions/userRoleModuleActions";

const TableAppComponent = ({ data }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { items, requestSort, sortConfig } = useSortableData(data);

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const [rowIsActive, setRowIsActive] = useState(null);


  const handleOnClickRow = (row) => {
    setRowIsActive(row.id);
    dispatch(cleanUserRoleSelected());
    dispatch(startGetRolesByUserIdSelected(row));
    dispatch(startGetModulesByUserIdSelected(row));
  };

  const getStyleSortI = (accessor, sortConfig) => {
    let styleSort;
    if (accessor === sortConfig?.key && sortConfig.direction === "ascending") {
      styleSort = "fa fa-fw fa-sort-down table-icon-color-sort";
    } else if (accessor === sortConfig?.key && sortConfig.direction === "descending") {
      styleSort = "fa fa-fw fa-sort-up table-icon-color-sort";
    } else {
      styleSort = "fa fa-fw fa-sort table-icon-color-sort-no";
    }
    return styleSort;
  };

  const HeadersQ = () => {

    return (
      <tr>
        <th>
          <button onClick={() => requestSort("first_name")} className={getClassNamesFor("first_name")} style={{ backgroundColor: "transparent" }}>
            {t("admin.users.first_name")}
            <i className={getStyleSortI("first_name", sortConfig)}></i>
          </button>
        </th>
        <th>
          <button onClick={() => requestSort("last_name")} className={getClassNamesFor("last_name")} style={{ backgroundColor: "transparent" }}>
            {t("admin.users.last_name")}
            <i className={getStyleSortI("last_name", sortConfig)}></i>
          </button>
        </th>
        <th>
          <button onClick={() => requestSort("user_name")} className={getClassNamesFor("user_name")} style={{ backgroundColor: "transparent" }}>
            {t("admin.users.user_name")}
            <i className={getStyleSortI("user_name", sortConfig)}></i>
          </button>
        </th>
        <th>
          <button onClick={() => requestSort("email")} className={getClassNamesFor("email")} style={{ backgroundColor: "transparent" }}>
            {t("admin.users.email")}
            <i className={getStyleSortI("email", sortConfig)}></i>
          </button>
        </th>
      </tr>
    );
  };

  return (
    <div className="table-responsive-xxl" style={{ height: "600px", overflow: "scroll" }}>
      <table className="table">
        {/*<caption className="caption-down">
          <div className="d-flex justify-content-center">Export to: {tab}</div>
        </caption>*/}

        <thead className="table-light">
          {/*<tr>
            {cols &&
              cols.length > 0 &&
              cols.map((col) => <HeadersTable col={col} />)}
            </tr>*/}
          <HeadersQ />
        </thead>
        <tbody className="tbody-click">
          {data && data.length > 0 ? (
            items.map((rw) => (
              <tr
                key={rw.id}
                onClick={() => handleOnClickRow(rw)}
                
                className={rw.id === rowIsActive ? 'active-row' : ''}

              >
                {/*<td>
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`custom-checkbox-${rw.id}`}

                      checked={isChecked}
                      onChange={() => handleOnChange(rw)}
                    />
                  </div>
                </td>*/}
                <td>{rw.first_name}</td>
                <td>{rw.last_name}</td>
                <td>{rw.user_name}</td>
                <td>{rw.email}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="10"
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
              >
                {t("table.loading")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableAppComponent;